# Used by onboarding
# Shows the target element and hide itself

$(document).on 'click', '[data-behaviour="show-more"]', (e) ->
  e.preventDefault()
  $this = $(this).hide()
  $($this.data('view')).show()
